var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "url(#paint0_linear_172_1972)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 15.8333V13.3333C25.8333 13.1123 25.7455 12.9004 25.5893 12.7441C25.433 12.5878 25.221 12.5 25 12.5H14.1667C13.7246 12.5 13.3007 12.6756 12.9882 12.9882C12.6756 13.3007 12.5 13.7246 12.5 14.1667C12.5 14.6087 12.6756 15.0326 12.9882 15.3452C13.3007 15.6577 13.7246 15.8333 14.1667 15.8333H26.6667C26.8877 15.8333 27.0996 15.9211 27.2559 16.0774C27.4122 16.2337 27.5 16.4457 27.5 16.6667V20M27.5 20H25C24.558 20 24.134 20.1756 23.8215 20.4882C23.5089 20.8007 23.3333 21.2246 23.3333 21.6667C23.3333 22.1087 23.5089 22.5326 23.8215 22.8452C24.134 23.1577 24.558 23.3333 25 23.3333H27.5C27.721 23.3333 27.933 23.2455 28.0893 23.0893C28.2455 22.933 28.3333 22.721 28.3333 22.5V20.8333C28.3333 20.6123 28.2455 20.4004 28.0893 20.2441C27.933 20.0878 27.721 20 27.5 20Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.1667V25.8334C12.5 26.2754 12.6756 26.6994 12.9882 27.0119C13.3007 27.3245 13.7246 27.5001 14.1667 27.5001H26.6667C26.8877 27.5001 27.0996 27.4123 27.2559 27.256C27.4122 27.0997 27.5 26.8878 27.5 26.6667V23.3334",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_1972",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B892ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7300FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb3);
export default __webpack_public_path__ + "static/media/web3.0dffcc0e636f8b1e7680c4527bdd8f28.svg";
export { ForwardRef as ReactComponent };